import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { ReturnToSearchText } from 'embed/constants'

const ArrowBack = require('assets/components/arrow-back.svg')
const styles = require('./styles')

export interface ReturnToSearchProps {
  className?: string
  onClick: () => void
  text?: string
}

export const ReturnToSearch: React.FC<ReturnToSearchProps> = ({
  className,
  onClick,
  text = ReturnToSearchText.Default,
}) => (
  <ThemeConsumer>
    {({ colorPrimary, colorTextPrimary, fontFamilyPrimary }) => (
      <div
        data-test-id="app_returnToSearch"
        className={classnames(
          styles.returnToSearch,
          css`
            color: ${colorPrimary};
            font-family: ${fontFamilyPrimary};
            svg path {
              fill: ${colorPrimary};
            }
            &:hover {
              color: ${colorTextPrimary};
              svg path {
                fill: ${colorTextPrimary};
              }
            }
          `,
          className,
        )}
        onClick={onClick}
      >
        <ArrowBack /> {text}
      </div>
    )}
  </ThemeConsumer>
)
